import React, { useEffect, useState } from "react";

import Header from "./layout/header.js";
import Menu from "./layout/menu.js";

import SPM from './list-spm.js'
import Integracao from "./integracao";
import Estoque from "./estoque/estoque";
import Atendimento from "./atendimento/atendimento";
import Agenda from "./agenda.js";
import UserSettings from './user-settings'
import DocumentosTec from './documentos'
import VendasDashboard from './vendas'
import { NotificationContainer } from "react-notifications";

export default function Main(props) {
  return (
    <>
      {props.location.pathname.indexOf("documentostec") >= 0 && <DocumentosTec {...props} />}
      {props.location.pathname.indexOf("documentostec") < 0 &&
        <div className="wrapper">
          <NotificationContainer />
          <Header />
          <Menu />
          <section className="section-container" style={{ overflow: "auto" }}>
            <div
              style={{
                backgroundColor: "#fff",
                width: "100%",
                height: "100%",
                borderTopLeftRadius: "15px",
                overflowY: props.location.pathname === "/agenda" ? "" : "hidden",
                overflowX:
                  props.location.pathname === "/integracao" ? "scroll" : "",
              }}
            >
              {props.location.pathname === "/spm" ? (
                <SPM />
              ) : props.location.pathname === "/agenda" ? (
                <Agenda />
              ) : props.location.pathname === "/integracao" ? (
                <Integracao />
              ) : props.location.pathname === "/estoque" ? (
                <Estoque />
              ) : props.location.pathname === "/atendimento" ? (
                <Atendimento />
              ) : props.location.pathname === "/vendas" ? (
                <VendasDashboard />
              ) : props.location.pathname === "/user-settings" ? (
                <UserSettings />
              ) : (
                <></>
              )
              }
            </div>
          </section>
        </div>
      }
    </>
  );
}
